import { Rule, RuleObject } from 'antd/lib/form';
import { Buffer } from 'buffer';
import moment, { Moment, isMoment } from 'moment';
import { TRANSLATION_CODES } from './constants';
import {
    ComposedTranslationLabels,
    ComposedTranslationLabelsOptions,
    JDateProps,
    JFieldBaseProps,
    JRadioProps,
    JUploadProps,
    isJDateField
} from './models';
import { disabledDate, isFieldType, splitPhoneNumber } from './utils';

function evalScript(param: any, script: string) {
    return eval(script)(param);
}

export const validateScript = (script: any, param: any) => {
  if (script && (param?.value || param)) {
    let buff = new Buffer(script, 'base64');
    try {
      return evalScript(param, buff.toString('utf8'));
    } catch (e) {
      return true;
    }
  };
  return true;
}

export const getValidators = (fieldProps: JFieldBaseProps | JRadioProps | JUploadProps | JDateProps, labels: ComposedTranslationLabels) => {
    const arr: Rule[] = []
    if (isFieldType.PHONE(fieldProps.type)) {
        arr.push(validators.phone(labels.invalidPhone))
    }
    if (isJDateField(fieldProps)) {
        arr.push(validators.dateControl(labels.invalidDate, fieldProps.minDate, fieldProps.maxDate))
    }
    if (fieldProps.mandatory) {
        arr.push(validators.required(labels.required))
    }
    if (fieldProps.validationScript) {
        arr.push(validators.script(fieldProps.validationScript, labels.wrongFormat))
    }
    return arr
}

export const validators = {
    script: (validationScript: string, errorMessage: string) => ({
        validator(_: RuleObject, value: any) {
          // Check if validationScript and value are provided
          if ((validationScript && value)) {

            const scriptName = validationScript.replace("window.", "");

            // Check if the function exists on the window object
            // or if the function is base64 to use in eval()
            if (typeof (window as any)[scriptName] === "function" || isBase64(validationScript)){

              const result = isBase64(validationScript)
                ? validateScript(validationScript, { value: value })
                : (window as any)[scriptName](value)

              // Return the appropriate promise based on the result
              return result
                ? Promise.resolve()
                : Promise.reject(new Error(errorMessage));
            }
            else
            {
              // Return a resolved promise if the script doesn't exist
              return Promise.resolve();
            }
          }
          return Promise.resolve();
        }
    }),
    required: (message: string) => ({
        required: true,
        message
    }),
    confirmed: (name: (string | number)[], message: string): Rule => ({ getFieldValue }) => ({
        validator(_, value) {
            if (!value || getFieldValue(name) === value) {
                return Promise.resolve();
            }
            return Promise.reject(new Error(message));
        },
    }),
    phone: (message: string) => ({
        validator(_: unknown, value: string) {


            const {
                number
            } = splitPhoneNumber(value)

            if ((!number && !value) || /^[0-9]{3,16}$/.test(number || value)) {
                return Promise.resolve();
            }

            return Promise.reject(new Error(message));
        }
    }),
    dateControl: (message: string, minDate?: Date, maxDate?: Date) => ({
        validator(_: unknown, value: (Moment | string) | (Moment | string)[]) {
            if (Array.isArray(value)) {
                for (let _value of value) {
                    _value = isMoment(_value) ? _value : moment(_value)
                    if (disabledDate(_value, minDate, maxDate)) {
                        return Promise.reject(new Error(message));
                    }
                }
            } else {
                let _value = isMoment(value) ? value : moment(value)
                if (disabledDate(_value, minDate, maxDate)) {
                    return Promise.reject(new Error(message));
                }
            }
            return Promise.resolve();
        }
    })
}



export function getValidationLabels(
    label: string,
    translateWord: (code: string, opt: any) => string,
    options: ComposedTranslationLabelsOptions = {}
) {
    const labels: ComposedTranslationLabels = {
        required: '',
        confirm: '',
        noMatch: '',
        wrongFormat: '',
        invalidDate: '',
        invalidPhone: ''
    }
    if (!options.ignoreRequired) {
        labels.required = translateWord(TRANSLATION_CODES.REQUIRED, { label })
    }
    if (!options.ignoreConfirm) {
        labels.confirm = translateWord(TRANSLATION_CODES.CONFIRM, { label })
    }
    if (!options.ignoreNoMatch) {
        labels.noMatch = translateWord(TRANSLATION_CODES.NO_MATCH, { label })
    }
    if (!options.ignoreInvalidDate) {
        labels.invalidDate = translateWord(TRANSLATION_CODES.INVALID_DATE, { label })
    }
    if (!options.ignoreInvalidPhone) {
        labels.invalidPhone = translateWord(TRANSLATION_CODES.INVALID_PHONE, { label })
    }
    labels.wrongFormat = options.validationMessage || translateWord(TRANSLATION_CODES.WRONG_FORMAT, { label })
    return labels
}

export const isBase64 = (str: string|null|undefined): boolean => {
  try
  {
    return !str ? false : btoa(atob(str)) === str;
  }
  catch (err)
  {
    return false;
  }
}